export const GROUP_BY_OPTIONS = [
  { id: null, label: 'Time' },
  { id: 'survey_name', label: 'Survey name', key: 'g1.name' },
  { id: 'job_name', label: 'Job name', key: 'g1.name' },
  { id: 'job_stage', label: 'Job stage', key: 'g1.name' },
  { id: 'primary_recruiter', label: 'Primary recruiter', key: 'g1.name' },
  { id: 'primary_hm', label: 'Primary hiring manager', key: 'g1.name' },
  { id: 'department', label: 'Department', key: 'g1.name' },
  { id: 'job_location', label: 'Office', key: 'g1.name' },
  { id: 'job_type', label: 'Work type', key: 'g1.name' },
];

export const BREAKDOWN_OPTIONS = [
  { id: null, label: 'None' },
  { id: 'survey_name', label: 'Survey name', key: 'g1.name' },
  { id: 'job_name', label: 'Job name', key: 'g1.name' },
  { id: 'job_stage', label: 'Job stage', key: 'g1.name' },
  { id: 'primary_recruiter', label: 'Primary recruiter', key: 'g1.name' },
  { id: 'primary_hm', label: 'Primary hiring manager', key: 'g1.name' },
  { id: 'department', label: 'Department', key: 'g1.name' },
  { id: 'job_location', label: 'Office', key: 'g1.name' },
  { id: 'job_type', label: 'Work type', key: 'g1.name' },
];
